const initialState = {
  retrieveChartBegin: false,
  retrieveChartError: false,
  retrieveChartDataBegin: false,
  retrieveChartDataSuccess: null,
  retrieveChartDataFailure: null,
  chart100: [],
  chart101: [],
  chart102: [],
  chart103: [],
  chart104: [],
  chart105: [],
  chart106: [],
  chart107: [],
  chart108: [],
  chart109: [],
  chart110: [],
  chart111: [],
  chart112: [],
  chart113: [],
  chart114: [],
  chart115: [],
  chart116: [],
  chart117: [],
  chart118: [],
  chart119: [],
  chart120: [],
  chart121: [],
  chart122: [],
  chart123: [],
  chart124: [],
  chart125: [],
  chart126: [],
  retrieveLabelsBegin: false,
  retrieveLabelsError: false,
  retrieveLabelsSuccess: false,
  labels: {
    chart100: null,
    chart101: null,
    chart102: null,
    chart103: null,
    chart104: null,
    chart105: null,
    chart106: null,
    chart107: null,
    chart108: null,
    chart109: null,
    chart110: null,
    chart111: null,
    chart112: null,
    chart113: null,
    chart114: null,
    chart115: null,
    chart116: null,
    chart117: null,
    chart118: null,
    chart119: null,
    chart120: null,
    chart121: null,
    chart122: null,
    chart123: null,
    chart124: null,
    chart125: null,
    chart126: null
  },
  deletedLabel: {
    chart100: null,
    chart101: null,
    chart102: null,
    chart103: null,
    chart104: null,
    chart105: null,
    chart106: null,
    chart107: null,
    chart108: null,
    chart109: null,
    chart110: null,
    chart111: null,
    chart112: null,
    chart113: null,
    chart114: null,
    chart115: null,
    chart116: null,
    chart117: null,
    chart118: null,
    chart119: null,
    chart120: null,
    chart121: null,
    chart122: null,
    chart123: null,
    chart124: null,
    chart125: null,
    chart126: null
  },
  commentOrTweetAfterToggling: null
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/redux/initialState.js